import React from 'react';
import { useTranslation } from 'react-i18next';

import { domain } from 'api';
import { Link } from 'components/Link/Link';
import { Apple } from 'components/Icon/SVG';

export const SignInWithApple = () => {
  const { t } = useTranslation();
  return (
    <Link href={`${domain}/apple/login`} className="bg-white text-black rounded-md p-2 font-medium flex items-center justify-center">
      <Apple className="mr-4 w-4 h-4" />
      {t('auth.logInWith')} Apple
    </Link>
  );
}
